import { StyledPopup } from "components/Common/StyledPopup"
import TextField from "components/inputs/TextField"
import { DATE_PARAM_FORMAT } from "config"
import dayjs from "dayjs"
import { Fragment, useState } from "react"
import BirthDatePicker from "../BitrhDatePicker"

interface IBirthDatePickerFormItemProps {
  value: string
  onChange: (date: string) => void
  label: string
}

const BirthDatePickerFormItem = (props: IBirthDatePickerFormItemProps) => {
  const { value, onChange, label } = props
  const [showCalendar, setShowCalendar] = useState(false)
  return (
    <Fragment>
      <StyledPopup
        bodyStyle={{ padding: 0 }}
        position="top"
        visible={showCalendar}
        onMaskClick={() => setShowCalendar(false)}
      >
        {showCalendar && (
          <BirthDatePicker
            onChange={(date) => {
              onChange(date.format(DATE_PARAM_FORMAT))
              setShowCalendar(false)
            }}
            value={dayjs(value, DATE_PARAM_FORMAT)}
          />
        )}
      </StyledPopup>

      <TextField
        readOnly
        value={dayjs(value, DATE_PARAM_FORMAT).format("MMM D, YYYY")}
        label={label}
        onFocus={() => setShowCalendar(true)}
      />
    </Fragment>
  )
}

export default BirthDatePickerFormItem
